
import FirstComponent from "./abraca-keralty/FirstComponent"
import DonationSection from "./abraca-keralty/DonationSection"
import TransparencySection from "./abraca-keralty/TransparencySection"
import HelpProjects from "./abraca-keralty/HelpProjects"
function abracaKeralty() {
    return (
        <div className='flex flex-col'>
            <FirstComponent />
            <DonationSection />
            <TransparencySection />
            <HelpProjects />
        </div>
    )
}

export default abracaKeralty
